<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-card :title="$t('lab.test-report-result')">
      <div>
        <!-- Search form -->
        <b-row class="mt-3">
          <b-col md="6" cols="12">
            <AutoComplete
              :label="$t('lab.patient_name')"
              :placeholder="$t('lab.patient_name')"
              v-model="patientCardId"
              :serializer="(val) => val.patient_card.id"
              param-query="filter[id]=-id"
              other-query="include=patientCard"
              endpoint="patient-lab"
              text-title="name"
              style="flex: 1"
            />
          </b-col>
          <b-col md="6" cols="12">
            <AutoComplete
              :label="$t('lab.test_report_name')"
              :placeholder="$t('lab.test_report_name')"
              v-model="testReportId"
              :serializer="(val) => val.id"
              param-query="filter[id]=-id"
              endpoint="testReport"
              text-title="name"
              style="flex: 1"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-3">
         

          <b-col md="12" cols="12">
            <b-form-group
              :label="$t('common.created-at')"
              label-for="production_date"
            >
              <datepicker
                v-model="from_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
         
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getTestReportField()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
                              {{ $t("surgery.Print-Hospital-Expenses") }}
                          </b-button> -->
          </b-col>
        </b-row>

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>
            {{ $t("lab.test-report-result-table") }}
          </h2>
          <!-- <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("lab.add-test-report-fields") }}
          </b-button> -->
        </div>

        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(value)="data">
            <ol>
              <li
                v-for="item in JSON.parse(data.item.data)"
                :key="item.id"
                style="text-wrap: nowrap"
              >
                {{ item.name }} :
                <b-badge variant="primary" style="margin-bottom: 5px">{{
                  item.value
                }}</b-badge>
              </li>
            </ol>
          </template>

          <template #cell(created_at)="data">
            <!-- <b-badge variant="primary">{{ data.item.created_at }}</b-badge> -->
            {{ data.item.created_at }}
          </template>
          <template #cell(print)="data">
            <b-button
              variant="primary"
              @click="printTestReportResult(data.item)"
              pill
              size="sm"
            >
              {{ $t("common.print") }}
            </b-button>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                :noEdit="true"
                deletePerm="delete-patient"
                editPerm="update-patient"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getTestReportField()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <TestReportResult ref="TestReportResult" :data="printData" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
  BFormRadioGroup,
  BFormRadio,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const TestReportResult = () =>
  import("@/components/printables/TestReportResult.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import AutoComplete from "@/components/common/AutoComplete.vue";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    Doctor,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    BFormRadioGroup,
    BFormRadio,
    TestReportResult,
    AutoComplete,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        test_report_id: "",
        category: "",
        type: "",
        is_required: 1,
        required_range: "",
        default: "",
        options: [],
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        test_report_id: "",
        category: "",
        type: "",
        is_required: "",
        required_range: "",
        default: "",
        options: [],
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        {
          key: "patient_card.patient.name",
          sortable: true,
          label: this.$t("lab.patient-name"),
        },
        //   {
        //     key: "test_report.name",
        //     sortable: true,
        //     label: this.$t("lab.test-name"),
        //   },
        {
          key: "test_report_name",
          sortable: true,
          label: this.$t("lab.test-name"),
        },

        // {
        //   key: "test_report_field_name",
        //   sortable: true,
        //   label: this.$t("lab.test-report-field-name"),
        // },

        {
          key: "value",
          sortable: true,
          label: this.$t("lab.flied-name-and-value"),
        },

        //   {
        //     key: "default",
        //     sortable: true,
        //     label: this.$t("lab.default"),
        //   },
        //   {
        //     key: "options",
        //     sortable: true,
        //     label: this.$t("lab.options"),
        //   },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },

        {
          key: "print",
          label: this.$t("common.print"),
        },

        {
          key: "Actions",
          label: this.$t("common.actions"),
          thStyle: { width: "150px" },
        },
      ],

      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,

      reference_range: "",
      rh: "",
      production_date: "",
      expiration_date: "",
      name: "",
      inserted_at: "",
     
      statusOptions: ["available", "dispensed"],
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
      type: "",
      test_report_id: "",
      test_report_fields: [],
      test_report_fields_count: 0,
      option: "",
      hoveredOption: null,
      requiredOptions: [
        { text: this.$t("lab.required"), value: 1 },
        { text: this.$t("lab.not-required"), value: 0 },
      ],
      test_report_name: "",
      printData: null,
      patientCardId: null,
      testReportId: null,
    };
  },
  mounted() {
    this.getTestReportField();
    this.EditForm.test_report_id = this.$route.params.test_report_id;
  },
  watch: {
    searchDate(newVal) {
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    testofication(title, message, variant = "info", icon = "success") {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title: title,
          icon: icon,
          variant: variant,
          text: message,
        },
      });
    },
    printTestReportResult(item) {
      // Set the data to be printed
      this.printData = { ...item };
      this.printData.data = JSON.parse(this.printData.data);
      console.log(this.printData.data);
      this.printData.data = this.printData.data.reduce((acc, item) => {
        // Find if the category already exists in the accumulator
        const categoryIndex = acc.findIndex(
          (group) => group.category === item.category
        );

        if (categoryIndex !== -1) {
          // If the category exists, push the item to the data array
          acc[categoryIndex].data.push(item);
        } else {
          // If the category does not exist, create a new group
          acc.push({
            category: item.category,
            data: [item],
          });
        }

        return acc;
      }, []);

      console.log(this.printData.data);

      setTimeout(() => {
        this.$refs.TestReportResult.generateReport();
      }, 200);
    },

    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
          test_report_id: this.$route.params.test_report_id,
          options: [],
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.test_report_id = item.test_report_id;
        this.EditForm.category = item.category;
        this.EditForm.type = item.type;
        this.EditForm.is_required = item.is_required === 1 ? 1 : 0;
        this.EditForm.reference_range = item.reference_range;
        this.EditForm.default = item.default;
        this.EditForm.options = JSON.parse(item.options);

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getTestReportField() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testReportResult?page=${this.page}&take=${
        this.searchDate && (this.from_date || this.to_date) ? 1000 : 15
      }&sort=-id&include=patientCard`;

      if (this.testReportId) {
        url += `&filter[test_report_id]=${this.testReportId}`;
      }
      if (this.patientCardId) {
        url += `&filter[patient_card_id]=${this.patientCardId}`;
      }

      if (this.from_date) {
        url += `&filter[created_at]=${this.formatDate(
          this.from_date
        )}`;
      }
     

      await this.getList(url);
      this.dataCount = this.all_data.total;

      // Use Promise.all to resolve all promises returned by the map function
      this.data = await Promise.all(
        this.all_data.data.map(async (item) => {
          return {
            ...item,
            test_report_name: await this.getTestReportName(item.test_report_id),
          };
        })
      );

      //   console.log("this.data", this.data);
      this.loading = false;
    },
    async getTestReportName(id) {
      //   console.log("id", id);
      await this.getList(`/testReport/${id}`);
      //   console.log("response", this.all_data);
      return this.all_data.name;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/testReportResult/${this.deleteForm.id}`)
        .then((response) => {
          this.getTestReportField();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.name,
            },
          });
        });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
